"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = CompanyCalendarCard;
exports.AgendaItem = AgendaItem;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importDefault(require("react"));
const cancelable_promise_1 = require("cancelable-promise");
const react_native_fontawesome_1 = require("@fortawesome/react-native-fontawesome");
const react_native_1 = require("react-native");
const Theme_1 = require("../Theme");
const ThemeContext_1 = require("../ThemeContext");
const UserContext_1 = require("../contexts/UserContext");
const Card_1 = __importDefault(require("../components/Card"));
const CardTitle_1 = __importDefault(require("../components/CardTitle"));
const react_i18next_1 = require("react-i18next");
const react_native_calendars_1 = require("react-native-calendars");
const CompanyCalendar_1 = __importDefault(require("../api/CompanyCalendar"));
const Button_1 = __importDefault(require("../components/Button"));
const Helper_1 = require("../Helper");
const moment_1 = __importDefault(require("moment"));
const ResponsiveContext_1 = require("../contexts/ResponsiveContext");
const useStyles = () => {
    const THEME = (0, ThemeContext_1.useTheme)();
    const { size } = (0, ResponsiveContext_1.useResponsiveContext)();
    return react_native_1.StyleSheet.create({
        item: {
            flex: 1,
            alignItems: 'center',
            flexDirection: 'row',
            paddingHorizontal: 12,
            paddingVertical: 12
        },
        itemTitleText: {
            color: THEME.Text,
            paddingRight: 6,
            marginTop: 2,
            fontSize: 12,
        },
        itemSubtitleText: {
            color: THEME.Text,
            paddingRight: 6,
            fontSize: 12,
        },
        emptyItem: {
            flex: 1,
            alignItems: 'center',
            flexDirection: 'row',
            padding: 18,
            marginBottom: 2,
            borderRadius: 4,
            backgroundColor: `${THEME.TextLight}11`,
        },
        emptyItemText: {
            color: THEME.TextNull,
            fontSize: size != 'sm' ? 14 : 12,
        },
        section: {
            backgroundColor: THEME.CardBackground,
            color: THEME.TextLight,
            textTransform: 'capitalize'
        }
    });
};
function CompanyCalendarCard(props) {
    const { t } = (0, react_i18next_1.useTranslation)();
    const THEME = (0, ThemeContext_1.useTheme)();
    const ChartColors = (0, Theme_1.useChartColors)();
    const userContext = react_1.default.useContext(UserContext_1.UserContext);
    const { size } = (0, ResponsiveContext_1.useResponsiveContext)();
    const promise = react_1.default.useRef(null);
    const [status, setStatus] = react_1.default.useState('loading');
    const [backgroundStatus, setBackgroundStatus] = react_1.default.useState('');
    const [backgroundData, setBackgroundData] = react_1.default.useState([]);
    const [agendaListSections, setAgendaListSections] = react_1.default.useState([]);
    const today = new Date();
    const [currentMonth, setCurrentMonth] = react_1.default.useState((new Date().getMonth() + 1).toString().padStart(2, "0"));
    const [currentYear, setCurrentYear] = react_1.default.useState(new Date().getFullYear().toString());
    const [startDay, setStartDay] = react_1.default.useState(null);
    const [endDay, setEndDay] = react_1.default.useState(null);
    const [startDate, setStartDate] = react_1.default.useState(null);
    const [endDate, setEndDate] = react_1.default.useState(null);
    const sdate = { color: ChartColors[0] };
    const pdate = { color: ChartColors[1] };
    const hdate = { color: ChartColors[2] };
    const bdate = { color: ChartColors[3] };
    const holdate = { color: ChartColors[4] };
    const mdate = { color: ChartColors[5] };
    const cdate = { color: ChartColors[7] };
    const benefits = { color: ChartColors[9] };
    const weekDayOptions = [
        { label: t('company:text.sunday'), value: "sunday", short: "D" },
        { label: t('company:text.monday'), value: "monday", short: "L" },
        { label: t('company:text.tuesday'), value: "tuesday", short: "M" },
        { label: t('company:text.wednesday'), value: "wednesday", short: "X" },
        { label: t('company:text.thursday'), value: "thursday", short: "J" },
        { label: t('company:text.friday'), value: "friday", short: "V" },
        { label: t('company:text.saturday'), value: "saturday", short: "S" }
    ];
    const weekOfMonthOptions = [
        { label: t('company:text.firstWeek'), value: "1" },
        { label: t('company:text.secondWeek'), value: "2" },
        { label: t('company:text.thirdWeek'), value: "3" },
        { label: t('company:text.fourthWeek'), value: "4" },
        { label: t('company:text.lastWeek'), value: "5" },
    ];
    const getDayLabel = (date) => {
        return date ? weekDayOptions[date.getUTCDay()]?.label : undefined;
    };
    function getDaySuffix(day) {
        if (10 <= day % 100 && day % 100 <= 20) {
            return `${day}${t('company:text.fourthSuffix')}`;
        }
        const suffixes = [t('company:text.firstSuffix'), t('company:text.secondSuffix'), t('company:text.thirdSuffix')];
        const suffix = suffixes[(day % 10) - 1] || t('company:text.fourthSuffix');
        return `${day}${suffix}`;
    }
    const getMonthlyPattern = (startDate, endDate, recurrenceMonthlyMode, recurrenceMonthlyOrdinal) => {
        const start = new Date(startDate);
        const end = new Date(endDate);
        if (isNaN(start.getTime()) || isNaN(end.getTime())) {
            return null;
        }
        if (recurrenceMonthlyMode == 'dayOfMonth') {
            return start.getTime() !== end.getTime() ? `${t('company:text.from').toLowerCase()} ${getDaySuffix(start.getUTCDate())} ${t('company:text.toThe')} ${getDaySuffix(end.getUTCDate())}` : `${t('company:text.onTheDay').toLowerCase()} ${getDaySuffix(start.getUTCDate())}`;
        }
        else if (recurrenceMonthlyMode == 'weekday') {
            const daysLabel = start.getTime() !== end.getTime() ? getDayLabel(start) + ' - ' + getDayLabel(end) : getDayLabel(start);
            const weekLabel = weekOfMonthOptions.find(w => w.value === recurrenceMonthlyOrdinal)?.label.toLowerCase() ?? '';
            return `${t('company:text.onThe').toLowerCase()} ${weekLabel} ${daysLabel}`;
        }
        return null;
    };
    const getWeeklyPattern = (startDate, endDate) => {
        const start = new Date(startDate);
        const end = new Date(endDate);
        if (isNaN(start.getTime()) || isNaN(end.getTime())) {
            return null;
        }
        const daysLabel = start.getTime() !== end.getTime() ? getDayLabel(start) + ' - ' + getDayLabel(end) : getDayLabel(start);
        return `${t('company:text.on').toLowerCase()} ${daysLabel}`;
    };
    const processData = (data) => {
        data.forEach((section) => {
            section.colors = [];
            // Replace API placeholders with translated text and add colors to days
            section.data.forEach((item) => {
                if (item.type == 'bdate') {
                    item.title = item.title.replace('bdate', t('company:text.birthday'));
                    item.color = bdate.color;
                    if (!section.colors.includes(bdate))
                        section.colors.push(bdate);
                }
                if (item.type == 'hdate') {
                    item.title = item.title.replace('hdate', t('company:text.workAnniversary'));
                    item.title = item.title.replace('yrs', t('company:text.yrs'));
                    item.color = hdate.color;
                    if (!section.colors.includes(hdate))
                        section.colors.push(hdate);
                }
                if (item.type == 'pdate') {
                    item.title = item.title.replace('pdate', t('company:text.payDay'));
                    item.color = pdate.color;
                    if (!section.colors.includes(pdate))
                        section.colors.push(pdate);
                }
                if (item.type == 'benefits') {
                    item.title = item.title;
                    item.color = benefits.color;
                    if (!section.colors.includes(benefits))
                        section.colors.push(benefits);
                }
                if (item.type == 'sdate') {
                    item.title = item.title.replace('sdate', t('company:text.submissionDue'));
                    if (item.subtitleTimes?.length > 0) {
                        let timeStr = Helper_1.Helper.FormatTime(item.subtitleTimes[0]);
                        item.subtitle = t('company:text.submissionTime') + ' ' + timeStr;
                    }
                    item.color = sdate.color;
                    if (!section.colors.includes(sdate))
                        section.colors.push(sdate);
                }
                if (item.type == 'holdate') {
                    item.title = item.title.replace('holdate', t('company:text.bankHoliday'));
                    item.color = holdate.color;
                    if (!section.colors.includes(holdate))
                        section.colors.push(holdate);
                }
                if (item.type == 'mdate') {
                    item.title = item.title.replace('mdate', t('company:text.maintenance'));
                    if (item.subtitle) {
                        if (item.subtitle.includes('mdatestart') && item.subtitle.includes('mdateend')) {
                            if (item.subtitleTimes?.length > 1) {
                                let startTimeStr = Helper_1.Helper.FormatTime(item.subtitleTimes[0]);
                                let endTimeStr = Helper_1.Helper.FormatTime(item.subtitleTimes[1]);
                                item.subtitle = t('common:text.starts') + ' ' + startTimeStr + ', ' + t('common:text.ends') + ' ' + endTimeStr;
                            }
                        }
                        else if (item.subtitle.includes('mdatestart')) {
                            if (item.subtitleTimes?.length > 0) {
                                let startTimeStr = Helper_1.Helper.FormatTime(item.subtitleTimes[0]);
                                item.subtitle = t('common:text.starts') + ' ' + startTimeStr;
                            }
                        }
                        else {
                            if (item.subtitleTimes?.length > 0) {
                                let endTimeStr = Helper_1.Helper.FormatTime(item.subtitleTimes[0]);
                                item.subtitle = t('common:text.ends') + ' ' + endTimeStr;
                            }
                        }
                    }
                    item.color = mdate.color;
                    if (!section.colors.includes(mdate))
                        section.colors.push(mdate);
                }
                if (item.type == 'cdate') {
                    item.title = item.title.replace('cdate', t('company:text.customEvents'));
                    item.color = cdate.color;
                    if (item.subtitle) {
                        let subtitleOriginal = item.subtitle;
                        item.subtitle = '';
                        let startDate = '';
                        let endDate = '';
                        let startTimeStr = '';
                        let endTimeStr = '';
                        if (item.subtitleTimes?.length > 1) {
                            startDate = item.subtitleTimes[0];
                            endDate = item.subtitleTimes[1];
                            startTimeStr = Helper_1.Helper.FormatDate(startDate);
                            endTimeStr = Helper_1.Helper.FormatDate(endDate);
                            item.subtitle = (subtitleOriginal.includes('cdatestart') && subtitleOriginal.includes('cdateend') && !subtitleOriginal.includes('recurrence')) ? t('common:text.starts') + ' ' + startTimeStr + ' | ' + t('common:text.ends') + ' ' + endTimeStr : '';
                        }
                        if (subtitleOriginal.includes('recurrence')) {
                            if (item.subtitleRecurrence?.length > 0) {
                                let recurrenceType = item.subtitleRecurrence[0];
                                let recurrenceMonthlyMode = '';
                                let recurrenceMonthlyOrdinal = '';
                                if (item.subtitleRecurrence?.length > 1)
                                    recurrenceMonthlyMode = item?.subtitleRecurrence[1];
                                if (item.subtitleRecurrence?.length == 3)
                                    recurrenceMonthlyOrdinal = item?.subtitleRecurrence[2];
                                let recurrenceDay = '';
                                switch (recurrenceType) {
                                    case 'weekly':
                                        recurrenceType = t('company:text.weekly');
                                        recurrenceDay = `${getWeeklyPattern(startDate, endDate)}`;
                                        break;
                                    case 'biweekly':
                                        recurrenceType = t('company:text.biweekly');
                                        recurrenceDay = `${getWeeklyPattern(startDate, endDate)}`;
                                        break;
                                    case 'monthly':
                                        recurrenceType = t('company:text.monthly');
                                        recurrenceDay = `${getMonthlyPattern(startDate, endDate, recurrenceMonthlyMode, recurrenceMonthlyOrdinal)}`;
                                        break;
                                    case 'annually':
                                        recurrenceType = t('company:text.annually');
                                        break;
                                    default:
                                        recurrenceType = '';
                                        recurrenceDay = '';
                                }
                                item.subtitle += recurrenceType + ' ' + recurrenceDay;
                            }
                        }
                        if (subtitleOriginal.includes('end')) {
                            if (item.subtitleRecurrenceEnd?.length == 2) {
                                let recurrenceEndMode = item.subtitleRecurrenceEnd[0]; //never, onDate, afterCount
                                let recurrenceEndModeValue = item.subtitleRecurrenceEnd[1]; // empty if never, date if onDate, count if afterCount
                                if (recurrenceEndMode == 'onDate') {
                                    let endDateStr = Helper_1.Helper.FormatDate(recurrenceEndModeValue);
                                    item.subtitle += ' | ' + t('company:text.endsOn') + ' ' + endDateStr;
                                }
                                else if (recurrenceEndMode == 'afterCount') {
                                    item.subtitle += ' | ' + t('company:text.repeatsFor') + ' ' + recurrenceEndModeValue + ' ' + t('company:text.recurrenceOccurrences');
                                }
                                else if (recurrenceEndMode == 'never') {
                                    item.subtitle += ' | ' + t('company:text.repeatsForever');
                                }
                                // no addition for never
                            }
                        }
                    }
                    if (!section.colors.includes(cdate))
                        section.colors.push(cdate);
                }
            });
            if (section.data.length == 0)
                section.data = [{ title: '', type: 'noevents', color: null }];
        });
        return data;
    };
    const runBackgroundFetch = () => {
        setBackgroundStatus('backgroundLoading');
        userContext.getToken()
            .then((token) => {
            CompanyCalendar_1.default.getCompanyDates(token).then((data) => {
                let bgData = processData(data);
                setBackgroundData(bgData);
                setBackgroundStatus('backgroundReady');
            });
        })
            .catch((err) => {
            setBackgroundStatus('backgroundError');
            console.log("Background fetch error (ignored)", err);
        });
    };
    const refresh = react_1.default.useCallback((forceRefresh = false) => {
        if (backgroundStatus === 'backgroundReady' && !forceRefresh)
            return;
        if (backgroundStatus === 'backgroundError' || backgroundStatus === '')
            runBackgroundFetch();
        promise.current?.cancel();
        setStatus('loading');
        const p = (0, cancelable_promise_1.cancelable)(userContext.getToken().then((token) => CompanyCalendar_1.default.getCompanyDates(token, Number(currentMonth), Number(currentYear))));
        promise.current = p;
        p.then((data) => {
            data = processData(data);
            setAgendaListSections(data);
            setStatus('done');
        })
            .catch((e) => {
            if (e?.isCanceled)
                return;
            setAgendaListSections([]);
            setStatus('error');
        });
    }, [currentMonth, currentYear]);
    const refreshRef = react_1.default.useRef(refresh);
    react_1.default.useEffect(() => {
        refresh();
        return () => {
            promise.current?.cancel();
        };
    }, [refresh]);
    // Update the refresh ref updated for the device event emitter
    react_1.default.useEffect(() => {
        refreshRef.current = refresh;
    }, [refresh]);
    const handleAddEdit = react_1.default.useCallback((customEvent) => {
        react_native_1.DeviceEventEmitter.emit("event.hideSnackbar");
        props.navigation.navigate('CalendarEventEdit', {
            id: customEvent?.id ?? '',
            startDate: startDate,
            endDate: endDate ?? startDate
        });
    }, [startDate, endDate]);
    react_1.default.useEffect(() => {
        const subscription = react_native_1.DeviceEventEmitter.addListener('event.calendarEventUpdate', () => {
            setBackgroundStatus('');
            refreshRef.current(true);
        });
        return () => {
            subscription.remove();
        };
    }, []);
    const displayDates = react_1.default.useMemo(() => {
        let result = JSON.parse(JSON.stringify(agendaListSections));
        result = result.filter((section) => section.title.split('-')[0] == currentYear && section.title.split('-')[1] == currentMonth);
        return result;
    }, [
        agendaListSections,
        currentYear,
        currentMonth
    ]);
    const isDark = (0, ThemeContext_1.useIsDark)();
    // markedDates considering agendaItems + range
    const markedDates = react_1.default.useMemo(() => {
        const md = {};
        // dots
        displayDates.forEach((section) => {
            if (section.data && section.data.length > 0)
                md[section.title] = { dots: section.colors, marked: true };
            else
                md[section.title] = { disabled: true };
        });
        // selection overlay
        if (startDay) {
            const from = startDay;
            const to = endDay ?? startDay;
            const start = (0, moment_1.default)(from);
            const end = (0, moment_1.default)(to);
            for (const d = (0, moment_1.default)(start); d.isSameOrBefore(end); d.add(1, 'days')) {
                const key = d.format('YYYY-MM-DD');
                md[key] = {
                    ...(md[key] || {}),
                    selected: true,
                    selectedColor: THEME.PrimaryLightest,
                    selectedTextColor: THEME.Secondary,
                };
            }
        }
        return md;
    }, [displayDates, startDay, endDay, isDark]);
    const handleDayPress = (date) => {
        const clicked = date.dateString;
        props.navigation.navigate('CompanyCalendar', { date: clicked });
    };
    const next = new Date(today);
    next.setFullYear(today.getFullYear() + 1);
    const maxDateObj = new Date(next.getFullYear(), 12, 0);
    const maxDate = maxDateObj.toISOString().slice(0, 10);
    const previous = new Date(today);
    previous.setFullYear(today.getFullYear() - 1);
    const minDateObj = new Date(previous.getFullYear(), 0, 1);
    const minDate = minDateObj.toISOString().slice(0, 10);
    return ((0, jsx_runtime_1.jsxs)(Card_1.default, { style: { paddingBottom: 12 }, children: [(0, jsx_runtime_1.jsx)(CardTitle_1.default, { title: t('common:screenTitles.companyCalendar'), style: { marginBottom: 6 }, children: (0, jsx_runtime_1.jsxs)(react_native_1.View, { style: { flexDirection: 'row', alignItems: 'center', gap: 6 }, children: [(0, jsx_runtime_1.jsx)(Button_1.default, { type: 'outline', color: status === 'done' ? THEME.Primary : THEME.TextDisabled, accessibilityHint: t('common:buttons.add'), onPress: () => handleAddEdit(null), disabled: status !== 'done', children: (0, jsx_runtime_1.jsx)(react_native_fontawesome_1.FontAwesomeIcon, { color: status === 'done' ? THEME.Primary : THEME.TextDisabled, icon: Theme_1.ICONS.Regular.Plus, size: 16 }) }), (0, jsx_runtime_1.jsxs)(Button_1.default, { type: 'outline', color: THEME.Primary, accessibilityHint: t('company:hints.companyCalendarCard'), onPress: () => props.navigation.navigate('CompanyCalendar'), children: [(0, jsx_runtime_1.jsx)(react_native_1.Text, { style: { color: THEME.Primary, fontSize: 14, fontWeight: '500', marginHorizontal: 6 }, children: t('common:buttons.view') }), (0, jsx_runtime_1.jsx)(react_native_fontawesome_1.FontAwesomeIcon, { color: THEME.Primary, icon: Theme_1.ICONS.Regular.ChevronRight, size: 14, style: { marginRight: 6 } })] })] }) }), (0, jsx_runtime_1.jsx)(react_native_1.View, { style: { flex: 1, paddingHorizontal: 0, marginBottom: 4 }, children: (0, jsx_runtime_1.jsx)(react_native_calendars_1.Calendar, { displayLoadingIndicator: status == 'loading', hideExtraDays: true, markedDates: markedDates, markingType: 'multi-dot', arrowsHitSlop: 8, maxDate: maxDate, minDate: minDate, disableArrowLeft: status == 'loading', disableArrowRight: status == 'loading', onDayPress: handleDayPress, onMonthChange: (date) => {
                        setStartDate(null);
                        setEndDate(null);
                        setStartDay(null);
                        setEndDay(null);
                        setCurrentMonth(date.month.toString().padStart(2, "0"));
                        if (date.year.toString() != currentYear)
                            setCurrentYear(date.year.toString());
                        if (backgroundStatus === 'backgroundReady') {
                            promise.current?.cancel();
                            setStatus('done');
                            setAgendaListSections(backgroundData);
                        }
                    }, renderArrow: direction => {
                        return ((0, jsx_runtime_1.jsx)(react_native_fontawesome_1.FontAwesomeIcon, { color: THEME.Text, icon: direction == 'right' ? Theme_1.ICONS.Regular.ChevronRight : Theme_1.ICONS.Regular.ChevronLeft }));
                    }, theme: {
                        calendarBackground: THEME.CardBackground,
                        selectedDayBackgroundColor: 'transparent',
                        selectedDayTextColor: THEME.Text,
                        todayTextColor: THEME.Secondary,
                        todayBackgroundColor: `${THEME.Secondary}11`,
                        dayTextColor: THEME.Text,
                        textDayFontSize: size != 'sm' ? 18 : 16,
                        monthTextColor: THEME.Text,
                        textMonthFontSize: size != 'sm' ? 18 : 16,
                        textDisabledColor: THEME.TextDisabled,
                        indicatorColor: THEME.Secondary
                    }, style: { marginHorizontal: size != 'sm' ? 0 : -12, paddingBottom: size != 'sm' ? 0 : 12 } }, `calendar-${isDark ? "dark" : "light"}`) })] }));
}
function AgendaItem(props) {
    const { t } = (0, react_i18next_1.useTranslation)();
    const THEME = (0, ThemeContext_1.useTheme)();
    const styles = useStyles();
    const { item } = props;
    if (item && item.title) {
        return ((0, jsx_runtime_1.jsxs)(react_native_1.View, { style: [styles.item, { borderLeftWidth: 6, borderColor: item.color || THEME.Primary, backgroundColor: (props.itemColorEnabled && item.color) ? `${item.color}11` : THEME.White }, props.itemColorEnabled ? { marginBottom: 4, borderRadius: 4 } : { borderBottomWidth: 1, borderBottomColor: THEME.LightGray }], children: [(0, jsx_runtime_1.jsxs)(react_native_1.View, { accessible: true, style: { flex: 1 }, children: [(0, jsx_runtime_1.jsx)(react_native_1.Text, { accessible: false, style: styles.itemTitleText, children: item.type == 'noevents' ? t('company:text.noEvents') : item.title }), !!item.subtitle && (0, jsx_runtime_1.jsx)(react_native_1.Text, { accessible: false, style: styles.itemSubtitleText, children: item.subtitle })] }), item.type === 'cdate' && ((0, jsx_runtime_1.jsx)(react_native_1.Pressable, { onPress: props.onEditPress, style: { paddingHorizontal: 8, paddingRight: 0, paddingVertical: 4 }, children: (0, jsx_runtime_1.jsx)(react_native_fontawesome_1.FontAwesomeIcon, { icon: Theme_1.ICONS.Regular.Pen, size: 14, color: THEME.Primary }) }))] }));
    }
    else {
        return ((0, jsx_runtime_1.jsx)(react_native_1.View, { style: styles.emptyItem, children: (0, jsx_runtime_1.jsx)(react_native_1.Text, { style: styles.emptyItemText, children: t('company:text.noEvents') }) }));
    }
}
;
